import { render, staticRenderFns } from "./InsightCategoryArticle.vue?vue&type=template&id=035adba2&scoped=true&"
import script from "./InsightCategoryArticle.vue?vue&type=script&lang=js&"
export * from "./InsightCategoryArticle.vue?vue&type=script&lang=js&"
import style0 from "./InsightCategoryArticle.vue?vue&type=style&index=0&id=035adba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035adba2",
  null
  
)

export default component.exports